import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Alert, Button, LinearProgress, Typography } from '@mui/material';
import baseURL from '../../../Config';
export default function GenerationProgress({ date, token, job, onJob, onResult, blocked = false }) {
    const [error, setError] = useState(false);
    const observedRunning = useRef(null);
    const [displayed, setDisplayed] = useState(null);
    const resultHandler = useRef(onResult);
    resultHandler.current = onResult;
    const update = useRef(onJob);
    update.current = onJob;
    const endpoint = baseURL + 'parlevel/route-generation-jobs/latest?serviceDate=' + encodeURIComponent(date);
    useEffect(() => {
        let cancelled = false;
        let timer;
        const read = async () => {
            try {
                const response = await axios({ method: 'get', url: endpoint, headers: { authorization: 'Bearer ' + token } });
                if (cancelled) return;
                setError(false); update.current(response.data.data);
                if (response.data.data?.status === 'running') timer = setTimeout(read, 2000);
            } catch { if (!cancelled) { setError(true); timer = setTimeout(read, 5000); } }
        };
        read();
        return () => { cancelled = true; clearTimeout(timer); };
    }, [endpoint, token, job?._id]);
    useEffect(() => {
        if (!job?._id || (job.service_date && job.service_date !== date)) return;
        const key = date + ':' + job._id;
        if (job.status === 'running') observedRunning.current = key;
        if (job.status !== 'completed' || observedRunning.current !== key || displayed === key || blocked || !job.result || job.result.preview_applied || job.result.preview_expired) return;
        // Only a job observed running in this view may update it automatically.
        // Never replay an old completed result or overwrite unsaved work.
        observedRunning.current = null;
        setDisplayed(key);
        resultHandler.current(job.result, false);
    }, [date, job, blocked, displayed]);
    if (error) return <Alert severity="warning">No se pudo consultar el progreso. Se volverá a consultar; una desconexión no cancela la generación.</Alert>;
    if (!job) return null;
    return <Alert severity={job.status === 'failed' ? 'warning' : 'info'} sx={{ mt: 1 }}>
        {job.status === 'running' ? <><Typography variant="body2">Generando: {job.progress?.completed || 0} de {job.progress?.total || '…'} rutas · {job.progress?.current_route || 'Consultando fuentes'}</Typography><LinearProgress /></>
            : job.status === 'failed' ? job.error : <><Typography variant="body2">La última generación terminó. Sus resultados están guardados aunque cierre esta página.</Typography>{job.result?.preview_applied ? <Typography variant="body2">Nueva versión guardada. Actualice las propuestas para consultarla.</Typography> : job.result?.preview_expired ? <Typography variant="body2">La vista previa venció; genere otra para revisar datos actuales.</Typography> : <>{displayed === date + ':' + job._id ? <Typography variant="body2">{job.result?.preview_id ? 'Actualizando la nueva versión automáticamente.' : 'Resultados cargados en la lista de propuestas.'}</Typography> : <>{blocked && <Typography variant="body2">Los resultados se mostrarán cuando termine la operación actual y guarde o descarte los cambios pendientes.</Typography>}<Button onClick={() => onResult(job.result)}>Ver resultados de generación</Button></>}</>}</>}
    </Alert>;
}
